import { render, staticRenderFns } from "./VouchersList.vue?vue&type=template&id=523f1dc6&scoped=true"
import script from "./VouchersList.vue?vue&type=script&lang=js"
export * from "./VouchersList.vue?vue&type=script&lang=js"
import style0 from "./VouchersList.vue?vue&type=style&index=0&id=523f1dc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523f1dc6",
  null
  
)

export default component.exports